import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
Vue.prototype.$env_var = process.env
import * as moment from 'moment'
import fxViewMixins from './plugins/fxView/index.ts';
Vue.mixin(fxViewMixins);


import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import VueSimpleAccordion from 'vue-simple-accordion';
import 'vue-simple-accordion/dist/vue-simple-accordion.css';
 
Vue.use(VueSimpleAccordion);
import Datepicker from 'vue2-datepicker';
Vue.component('datepicker', Datepicker)

import Toasted from 'vue-toasted'
Vue.use(Toasted)
//==============vue-editor=======================
import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/js/third_party/spell_checker.min';
import 'froala-editor/js/third_party/image_tui.min';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)

//===============vue-cookies=================
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.$cookies.config('30d')
Vue.$cookies.config('7d','','',true)

//===============vue-chat-scroll=================
import VueChatScroll from 'vue-chat-scroll'
Vue.use(VueChatScroll)
//===============multiselect=====================
import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)
import 'vue-multiselect/dist/vue-multiselect.min.css';
//================feather icons==================
import VueFeather from 'vue-feather';
Vue.use(VueFeather);
//===============datatable=======================
import VueGoodTable from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
Vue.use(VueGoodTable);
//================paginate=======================
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)

//============clipboard========================
import VueClipboard from 'vue-clipboard2' 
Vue.use(VueClipboard)
//==============vee-validate=====================
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);
//==============flash-message====================

import VueFlashMessage from 'vue-flash-message';
Vue.use(VueFlashMessage);
require('vue-flash-message/dist/vue-flash-message.min.css');
//==============moment===========================
Vue.use(require('vue-moment'))
//===============loader==========================
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);
//=========phone number with country code========
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
Vue.component('vue-phone-number-input', VuePhoneNumberInput);

import AmCharts from 'amcharts3'
import AmSerial from 'amcharts3/amcharts/serial'

//===============language==========================
import i18n from '@/plugins/lang/i18n';
//========local components import globally=========


//window._ = require('../static/fxView/js/chartiq.js');
//window.__ = require('../static/fxView/js/quoteFeedSimulator.js');

import filterComponent from '@/components/fxView/shared/filterComponent'
Vue.component('filter-component', filterComponent)

import paginationComponent from '@/components/fxView/shared/pagination'
Vue.component('pagination', paginationComponent)
Vue.component('app-pagination', paginationComponent)

import loaderComponent from '@/components/fxView/shared/loader_component'
Vue.component('loader', loaderComponent)

import messageComponent from '@/components/fxView/shared/message_component'
Vue.component('message', messageComponent)

import no_trading_account from '@/components/fxView/shared/no_trading_account'
Vue.component('no-trading-account', no_trading_account)


import top_header_title from '@/components/fxView/shared/top_header_title'
Vue.component('app-top-header-title', top_header_title)


Vue.config.productionTip = false
const params = new URLSearchParams(window.location.search);
if(params.get("auth")){
  let data = { token : params.get("auth"), loggedIn : true, roles : '', email : '', profile : {} }
  localStorage.setItem('user', btoa(JSON.stringify(data)))
  /*router.replace('/dashboard')*/
  let src = document.location.origin+'/dashboard'
  location.replace(src);
}

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js